import React from 'react';
import './StoreAvailabilityStatuses.scss';
import StoreAvailabilityStatus from './StoreAvailabilityStatus/StoreAvailabilityStatus';

const StoreAvailabilityStatuses = () => {
  return (
    <div className="store-statuses">
      <StoreAvailabilityStatus status="inStock" title="In stock" />
      <StoreAvailabilityStatus status="stockLow" title="Stock low" />
      <StoreAvailabilityStatus status="outOfStock" title="Out of stock" />
    </div>
  );
};

export default StoreAvailabilityStatuses;
